import React, { useEffect } from 'react';
import { Form, Select, Spin } from 'antd';
import customerCompaniesConnect from '../../../../common/hoc/customerCompaniesConnect';

const { Option } = Select;

const SelectCustomer = props => {
  useEffect(() => {
    return getCustomerCompaniesSearchClear;
  }, []);

  const {
    form,
    disabled,
    customerCompanies,
    isLoading,
    getCustomerCompaniesSearch,
    getCustomerCompaniesSearchClear,
  } = props;

  const { getFieldDecorator } = form;

  const handleChange = val => {
    if (!val) getCustomerCompaniesSearchClear();
  };

  return (
    <div className="offer-card__item">
      <span className="label">Заказчик:</span>
      <Form.Item>
        {getFieldDecorator('customerCompany')(
          <Select
            getPopupContainer={trigger => trigger.parentNode}
            style={{ width: 368 }}
            notFoundContent={isLoading ? <Spin size="small" /> : null}
            allowClear={true}
            filterOption={false}
            placeholder="Выберите заказчика"
            showSearch
            onSearch={getCustomerCompaniesSearch}
            onChange={handleChange}
            disabled={disabled}
          >
            {customerCompanies &&
              customerCompanies.map(item => (
                <Option key={item.profile_id} value={item.profile_id}>
                  {item.subject && item.subject.subject_key === 'physical'
                    ? `ФЛ, ${item.lastname} ${item.name} ${
                        item.patronymic ? item.patronymic : ''
                      }`
                    : item.name_legal}
                </Option>
              ))}
          </Select>
        )}
      </Form.Item>
    </div>
  );
};

export default customerCompaniesConnect(SelectCustomer);
